import { useMutation } from '@tanstack/react-query';

import { useResetUserInfo } from '@/features/users';

import { deleteImage } from '../api';

export const useDeleteImage = () => {
  const resetUserInfo = useResetUserInfo();

  return useMutation({
    mutationFn: deleteImage,
    onSuccess: async () => {
      await resetUserInfo();
    },
    onError: () => {},
  });
};
